import React, { useMemo, useState } from 'react';

import { useGetLivestreamingTopVodQuery } from '../../redux/apis/analyticsManagement/aMLiveStreamingStatsApiSlice';
import BarChart from '../other/charts/BarChart';
import ComponentLoader from '../other/ComponentLoader';
import { Card, CardBody } from '../other/card/card';
import { LIVESTREAMING_PERIOD_LABELS, LIVESTREAMING_PERIOD_OPTIONS } from './livestreamingPeriodConstants';
import { rowsToBarChartData } from './livestreamingBarHelpers';

const CHART_HEIGHT = '500px';

const LiveStreamingTopPiratedVods = () => {
  const [period, setPeriod] = useState('year');

  const { data, isLoading, isFetching, isError, error } = useGetLivestreamingTopVodQuery({ period }, {
    refetchOnMountOrArgChange: true,
  });

  const rows = useMemo(() => {
    if (!Array.isArray(data)) return [];
    return data.map(r => ({
      ...r,
      _label: r?.campaign_name || (r?.campaign_id != null ? `Campaign ${r.campaign_id}` : ''),
    }));
  }, [data]);

  const barData = useMemo(() => rowsToBarChartData(rows, '_label', 'reported'), [rows]);
  const hasData = Object.keys(barData).length > 0;

  const getPeriodButtonClass = p =>
    `btn btn-sm bg-transparent ${period === p ? 'text-theme border-theme' : 'text-body-secondary border-secondary opacity-75'}`;

  return (
    <div className='row g-2 mt-1'>
      <div className='col-12'>
        <Card className='mb-0'>
          <CardBody className='relative p-0'>
            {isError ? (
              <div className='absolute inset-0 d-flex items-center justify-center p-3 text-danger small bg-white bg-opacity-75'>
                Failed to load.
                {error?.data?.message ? ` ${error.data.message}` : ''}
              </div>
            ) : null}
            <div className='p-4 d-flex flex-column gap-2'>
              <div className='d-flex fw-bold small'>Top Pirated VODs</div>
              <div className='d-flex flex-wrap align-items-center gap-2'>
                {LIVESTREAMING_PERIOD_OPTIONS.map(p => (
                  <button
                    key={p}
                    type='button'
                    className={getPeriodButtonClass(p)}
                    disabled={isFetching}
                    onClick={() => setPeriod(p)}
                  >
                    {LIVESTREAMING_PERIOD_LABELS[p]}
                  </button>
                ))}
              </div>
            </div>
            <div className='p-4 pt-0'>
              <div className='small text-body-secondary'>
                <div className='mt-2 position-relative' style={{ minHeight: CHART_HEIGHT }}>
                  {isFetching ? <ComponentLoader /> : null}
                  {hasData ? (
                    <BarChart data={barData} height={CHART_HEIGHT} />
                  ) : !isLoading ? (
                    <div
                      className='d-flex align-items-center justify-content-center text-center px-2'
                      style={{ minHeight: CHART_HEIGHT }}
                    >
                      No pirated VODs data for this period.
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default LiveStreamingTopPiratedVods;
